<script type="text/jsx">
import {
  StyledGlossary,
  StyledIconContainer,
  StyledContainer,
  StyledContent,
  StyledOverlay,
  StyledCose
} from './StyledGlossary'

export default {
  name: 'Glossary',
  data: () => ({
    show: false
  }),
  render () {
    return (
      <div
        onMouseover={() => { this.show = true }}
        onMouseleave={() => { this.show = false }}
      >
        <StyledGlossary>
          <StyledIconContainer>
            <img src={require('@/assets/glossary-icon.svg')} alt="" />
          </StyledIconContainer>
          { this.show && (
            <StyledOverlay
              onClick={() => (this.show = false)}
            >
              <StyledContainer>
                <StyledContent>
                  {this.$slots.default}
                </StyledContent>
                <StyledCose
                  onClick={() => (this.show = false)}
                >Закрыть</StyledCose>
              </StyledContainer>
            </StyledOverlay>
          )}
        </StyledGlossary>
      </div>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Glossary/Glossary.vue